// extracted by mini-css-extract-plugin
module.exports = {"logInButton":"landing-header_logInButton__1wiKN","registerButton":"landing-header_registerButton__2axzu"};